window.addEventListener('load', () => {
  load();
})

let map;
const markers = [];

const locations = [
  {lat: 34.98884767273864, lng: 135.7626226234887}, //本社
  {lat: 35.65010858586481, lng: 139.71260009917975}, //東京
  {lat: 34.73760673146801, lng: 135.49797989825794}, //大阪
  {lat: 35.00306464980637, lng: 135.9522897132281} //滋賀
]

//infowindowの内容
const info = [
  {
    name: '株式会社ガーネット 本社',
    postalcode: '600-8208',
    address: '京都府京都市下京区小稲荷町85-8 GARNET BLDG. KYOTO'
  },
  {
    name: '株式会社ガーネット 東京支社',
    postalcode: '150-0012',
    address: '東京都渋谷区広尾1-1-39 恵比寿プライムスクエア7F'
  },
  {
    name: '株式会社ガーネット 大阪支社',
    postalcode: '532-0003',
    address: '大阪府大阪市淀川区宮原4-4-63 新大阪千代田ビル別館6階'
  },
  {
    name: '株式会社ガーネット 滋賀支社',
    postalcode: '525-0059',
    address: '滋賀県草津市野路6-5-10'
  }
]

const load = () => {
  //map初期化
  let map = new google.maps.Map(document.getElementById('map'), {
    zoom: 15.5,
    center: {lat: 34.98884767273864, lng: 135.7626226234887},
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false,
  });

  for(let i = 0; i < locations.length; i++) {

    //マーカー設置
    markers[i] = new google.maps.Marker({
      position: locations[i],
      map
    });

    //infowindow設定
    const _string =
      '<div id="content" class="infowindow">' +
        '<div id="siteNotice"></div>' +
        '<h1 class="head">' + info[i].name + '</h1>' +
        '<div class="text">' +
          '<p>〒' + info[i].postalcode + '<br>' + info[i].address +  '</p>' +
        '</div>' +
      '</div>'

    const infowindow = new google.maps.InfoWindow({
      content: _string,
    });

    markers[i].addListener("click", () => {
      infowindow.open(map, markers[i])
    });

  }
}